module.exports = __webpack_public_path__ + "img/giftbox@2x.a09824b.jpg";